<template>
    <div class="bg-white" style="padding-top: 12px">
      <div class="mt_status_selected bg-white" @click="mtStatus = true">
        {{mtActiveStatus.name}}
        <i class="el-icon-caret-bottom"></i>
      </div>
      <mt-status-list @MTPayNow="MTShowPaySelect" ref="mt-status-list" :mtActiveStatus="mtActiveStatus"></mt-status-list>
      <vab-action-sheet v-model="mtStatus" :actions="mtStatusList" @select="mtStatusSelect" color="red"></vab-action-sheet>
      <payDialog ref="payDialog"></payDialog>
    </div>
</template>

<script>
import MTStatusList from './MTStatusList.vue'
import ActionSheet from 'vant/lib/action-sheet'
import 'vant/lib/action-sheet/style'
import payDialog from './payDialog.vue'
export default {
  components: {
    'mt-status-list': MTStatusList,
    'vab-action-sheet': ActionSheet,
    payDialog
  },
  data() {
    return {
      mtStatusList: [
        { name: `${this.$t('Order.List.Components.Mobile.AllOrder')}`, value: 'all_order', className: 'actionGreen' },
        { name: `${this.$t('Order.List.Components.Mobile.WaitingPayment')}`, value: 'waiting_payment', className: 'actionGreen' },
        { name: `${this.$t('Order.List.Components.Mobile.WaitingToShip')}`, value: 'waiting_to_ship', className: 'actionGreen' },
        { name: `${this.$t('Order.List.Components.Mobile.InTransit')}`, value: 'in_transit', className: 'actionGreen' },
        { name: `${this.$t('Order.List.Components.Mobile.RefundReturn')}`, value: 'Refund&Return', className: 'actionGreen' },
        { name: `${this.$t('Order.List.Components.Mobile.Completed')}`, value: 'completed', className: 'actionGreen' },
        { name: `${this.$t('Order.List.Components.Mobile.Cancel')}`, value: 'cancel', className: 'actionGreen' },
        { name: `${this.$t('Order.List.Components.Mobile.OrderInfoMissing')}`, value: 'order_info_missing', className: 'actionGreen' }
      ],
      mtActiveStatus: { name: `${this.$t('Order.List.Components.Mobile.AllOrder')}`, value: 'all_order' },
      mtStatus: false,
      statusParams: {}// 状态参数
    }
  },
  methods: {
    MTShowPaySelect(row) {
      this.$refs.payDialog.MTShow(row)
    },
    mtStatusSelect(item) {
      this.mtActiveStatus = item
      this.mtStatus = false
      this.$nextTick(() => {
        this.$refs['mt-status-list'].resetPage()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mt_status_selected {
  height: 38px;
  border: 1px solid #E0E0E0;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  margin: 0 12px 12px;
}
/deep/.van-tab {
  padding: 0 .2rem;
}
/deep/.van-tabs__nav {
  /deep/.van-tab:last-of-type {
    display: none;
  }
}
/deep/.van-tabs__nav >.van-tab:last-of-type {
  display: none;
}
</style>

<style lang="scss">
.MT_orderList_vanTab {
  .van-tabs__nav >.van-tab:nth-of-type(6) {
    display: none !important;
  }
}
.actionGreen:active{
  background-color: rgba(153, 196, 28, 0.08);
  color: #99C41C;
}
</style>
